var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../../lib";
export class ApiEpSocialAccountConnectInstagramBusiness {
}
_a = ApiEpSocialAccountConnectInstagramBusiness;
/**
 * Used to get list of facebook accounts, ready to connect inst
 */
ApiEpSocialAccountConnectInstagramBusiness.list = () => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/social-account/connect/instagram-business`,
        method: "GET",
    });
});
/**
 * Used to create instagram_business account via instagram external_id
 */
ApiEpSocialAccountConnectInstagramBusiness.create = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/social-account/connect/instagram-business`,
    method: "POST",
});
//# sourceMappingURL=instagram_business.js.map